import { useState } from 'react';
import { TerrainCleanupForm } from './terrain-cleanup-form';
import { TerrainCleanupGenerating } from './terrain-cleanup-generating';

export const TerrainCleanupGenerate: React.FC = () => {
  const [isGeneratingCleanup, setIsGeneratingCleanup] =
    useState<boolean>(false);

  return isGeneratingCleanup ? (
    <TerrainCleanupGenerating setIsGeneratingCleanup={setIsGeneratingCleanup} />
  ) : (
    <TerrainCleanupForm setIsGeneratingCleanup={setIsGeneratingCleanup} />
  );
};
